
import { createGlobalStyle,css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'pf_highway_sans_pro_lightRg';
    src: url('//cdn.viva.gr/app/fonts/AvertaPE/regular.woff2') format('woff2'),
         url('//cdn.viva.gr/app/fonts/AvertaPE/regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  body {
    font-family: 'pf_highway_sans_pro_lightRg', sans-serif;
  }
`;


export const colors = {
    primary: '#703EFF', //purple
    dark: '#3E228C',    //dark-purple, links/hover
    lightPrimary: '#F1E8FF', //dropdown light purple
    darkText: '#0D0C1C',//text -dark purple,almost black
    gray: '#9897A9',
    lightGray: '#BAB9C5',//light gray no one can see
    otherGray:'#F9FBFC',
    danger: '#FC2D33',//red
    warning: '#FCB041',//yellow
    success: '#28BE63',//green
    darkTitle: '#2F3030',//one title (Billing information) has this color
    warningAlert: '#FFF7EC',// alert yellow
    linkHovered: '#502CB5',//hovered link color
    linkPressed: '#2F1A6B'//pressed link color
};
 
export const borders = {
    lightGrayBorder: () => css` 
    border: 1px solid ${colors.lightGray};
`,
    primaryBorder: () => css`
    border: 1px solid ${colors.primary};
`,
    darkBorder: () => css`
    border: 1px solid ${colors.dark};
`,
};

export const fonts = {
    title: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
    font-size:20px;
    font-weight:600;
    color:${colors.darkText};
    `,
    smallTitle: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
    font-size:16px;
    font-weight:600;
    color:${colors.darkText};
    `,
    darkPurpleTitle: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
    font-size:16px;
    font-weight:600;
    color:${colors.dark};
    `,
    lightGrayText: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
     font-size:16px;
     font-weight:400;
     color:${colors.gray};
    `,
    lightGrayTextSmall: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
     font-size:14px;
     font-weight:400;
     color:${colors.lightGray};
    `,
    normalText: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
     font-size: 16px;
     font-weight: 400;
     color:${colors.darkText};
     `,
    normalTextBold: () => css`
     font-family: 'pf_highway_sans_pro_lightRg';
     font-size: 16px;
     font-weight: 600;
     color:${colors.darkText};
     `,
    grayTextBold: () => css`
     font-family: 'pf_highway_sans_pro_lightRg';
     font-size: 16px;
     font-weight: 600;
     color:${colors.gray};
     `,
    normalTextSmall: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
     font-size: 14px;
     font-weight: 400;
     color:${colors.darkText};
     `,
    normalTextSmallBold: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
     font-size: 14px;
     font-weight: 600;
     color:${colors.darkText};
     `,
    normalTextExtraSmall: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
     font-size: 12px;
     font-weight: 400;
     color:${colors.darkText};
     `,
    darkPurpleText: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
    font-size:16px;
    font-weight:400;
    color:${colors.dark};
    `,
    purpleText: () => css`
    font-family: 'pf_highway_sans_pro_lightRg';
    font-size:16px;
    font-weight:400;
    color:${colors.primary};
    `,
};

export const links = {
    linkSmallBold: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size: 14px;
        font-weight: 600;
        color: ${colors.primary};
        text-decoration: none;
        cursor:pointer;

        &:hover {
            color: ${colors.dark};
            text-decoration: none;
        }
    `,
    linkNormalBold: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size: 16px;
        font-weight: 600;
        color: ${colors.primary};
        text-decoration: none;
        cursor:pointer;

        &:hover {
            color: ${colors.dark};        
        }
         &:active {
            color: ${colors.dark};         
        }
    `,
    linkDarkBold: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size: 16px;
        font-weight: 600;
        color:  ${colors.dark};
        text-decoration: none;
        cursor:pointer;
          &:hover {
            text-decoration: none;
        }
    `,
    linkSmallDark: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size: 14px;
        font-weight: 400;
        color: ${colors.dark};
        text-decoration: none;
        cursor:pointer;

        &:hover {
            text-decoration: none;
        }
    `,
    linkNormalDark: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size: 16px;
        font-weight: 400;
        color: ${colors.dark};
        text-decoration: none;
        cursor:pointer;

        &:hover {
            text-decoration: none;
        }
    `,
    linkBrightPurple: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size:16px;
        font-weight:600;
        color: ${colors.primary};
        cursor:pointer;
        text-decoration: none;

        &:hover {
            text-decoration: none;
            color: ${colors.linkHovered};        
        }
        &:active {
            color: ${colors.linkPressed};         
        }
    `,
    linkSmallBrightPurple: () => css`
        font-family: 'pf_highway_sans_pro_lightRg';
        font-size: 14px;
        font-weight: 400;
        color: ${colors.primary};
        text-decoration: none;
        cursor:pointer;

        &:hover {
            text-decoration: none;
            color: ${colors.linkHovered};        
        }
        &:active {
            color: ${colors.linkPressed};         
        }
    `,
};





